import { asyncTypes } from 'store/_helpers';

const TYPES = {
  ...asyncTypes('UPDATE_ROUTING_AREA')
};

export default TYPES;
